<template>
    <div class="d-flex flex-column" style="overflow-y: auto; overflow-x: hidden" :style="height !== null ? `height:${height}px` : 'height: 100%'">
        <div>
            <slot name="header"></slot>
        </div>


        <div :class="dark ? 'primary' : 'no-bg'" v-if="multiple || showFilter" class="d-flex align-center">

            <div class="pl-1 flex-grow-0" v-if="selectAll !== null && showSelectAll">

                <v-tooltip right>
                    <template v-slot:activator="{ props }">
                        <v-btn
                                v-bind="props"
                                style="width: 32px; height: 32px"
                                text
                                small
                                :color="selectAll ? 'primary' : null"
                                icon
                                @click="selectAll = !selectAll"
                        >
                            <v-icon>{{ selectAll ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                        </v-btn>
                    </template>
                    <span>{{!selectAll ? 'Select All Items' : 'Clear Selection'}}</span>
                </v-tooltip>
            </div>

            <div class="px-2 py-1 flex-grow-1 " v-if="showFilter">
                <v-text-field
                        variant="contained"
                        :placeholder="filterLabel"
                        clearable
                        :hide-details="true"
                        prepend-inner-icon="mdi-magnify"
                        v-model="searchStr"
                        ref="myField"
                        class="mt-0 pt-0"
                ></v-text-field>
            </div>
            <div v-if="!showFilter && multiple" class="px-2 py-2 greyType--text">
                {{selectAll ? 'Select All Items' : 'Clear Selection'}}
            </div>
        </div>

        <div>
            <slot name="afterFilter"></slot>
        </div>
        <v-divider></v-divider>

        <div style="overflow-y: auto; overflow-x: hidden" class="flex-grow-1">

            <div v-for="(item, i) in displayItems" :key="i" class="c-d-flex c-align-center">
                <app-list-item
                        class="c-flex-grow-1"
                        :key="item[itemKey]"
                        :line1="headlineKey"
                        :line2="subLineKey"
                        :item="item"
                        :loading="loading ? loadingItems.includes(item) : false"
                        :showCheckBoxes="showCheckBoxes"
                        :selected="selectedItems.includes(item)"
                        @select="selectItem(item)"
                        @selection="selectionItem(item, $event)"
                >
                    <template v-slot:headline v-if="useHeadlineSlot">
                        <slot
                                name="headline"
                                :value="item"
                                :index="i"
                                :selected="selectedItems.includes(item)"
                        />
                    </template>
                    <template v-slot:action>
                        <slot
                                name="action"
                                :value="item"
                                :index="i"
                                :selected="selectedItems.includes(item)"
                        />
                    </template>
                </app-list-item>
            </div>

        </div>
        <div>
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
import AppListItem from "@/components/Shared/AppList/AppListItem";
const {arrPopulated, blankString} = require("@/core/codeFunctions");
export default {
    components: {AppListItem},
    emits: ["input"],
    props: {
        items: {
            type: Array,
            default: () => {
                return []
            }
        },
        itemKey: {default: null, type: String, required: true},
        returnObject: {default: false, type: Boolean},
        showCheckBoxes: {default: false, type: Boolean},
        multiple: {default: true, type: Boolean},
        loading: {default: null, type: [Array, Object, Number, String, Boolean]},

        headlineKey: String,
        subLineKey: String,

        value: {default: null, type: [Array, Object, Number, String]},
        // {icon, color, cb, hoverItem}
        showFilter: {default: true, type: Boolean},

        filterLabel: {default: 'Search', type: String},
        dark: {default: false, type: Boolean},
        height: {default: null, type: Number},
        showSelectAll: {default: true, type: Boolean},
        customSortFn: Function,
        useHeadlineSlot: {type: Boolean, default: false},
        autoFocus: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            searchStr: null,
            con: console,
        }
    },
    mounted() {
        if (this.autoFocus)
            setTimeout(() => {
                this.focusSearch()
            }, 500)
    },
    methods: {

        focusSearch() {
            try {
                this.$refs.myField.focus()
            } catch (e) {
                //
            }
        },

        clearFilter() {
            this.searchStr = null;
        },
        selectItem(item) {
            this.$emit('input', this.multiple ? [(this.returnObject ? item : item[this.itemKey])] : (this.returnObject ? item : item[this.itemKey]));
        },
        selectionItem(item, add) {
            let vm = this;
            function input(val) {vm.$emit('input', val);}

            if (this.multiple) {

                if (arrPopulated(this.value)) {
                    input(add
                            ? (
                                    this.returnObject
                                            ? this.value.concat([item])
                                            : this.value.concat([item[this.itemKey]])
                            )
                            : (
                                    this.returnObject
                                            ? this.value.filter(obj => obj !== item)
                                            : this.value.filter(obj => obj !== item[this.itemKey])
                            )
                    )
                } else {
                    input(add
                            ? (
                                    this.returnObject
                                            ? [item]
                                            : [item[this.itemKey]]
                            )
                            : null
                    )
                }
            } else {
                return add
                        ? input(this.returnObject ? item : item[this.itemKey])
                        : input(null)
            }
        }
    },
    computed: {
        displayItems() {
            return this.items
                    .filter(obj => !this.searchStr
                            ? true
                            : obj[this.headlineKey]
                                    ? (obj[this.headlineKey].toLowerCase().includes((this.searchStr || '').toLowerCase()))
                                    : false
                    )
                    .sort(this.customSortFn ? this.customSortFn : (a,b) => (!blankString(a[this.headlineKey]) ? a[this.headlineKey] : '') < (!blankString(b[this.headlineKey]) ? b[this.headlineKey] : '') ? -1 : 1);
        },

        selectAll: {
            get() {
                if (!this.multiple) {
                    return null
                } else {
                    return !!this.value && this.value.length
                }
            },
            set(val) {
                this.$emit('input', !val
                        ? []
                        : (
                                this.returnObject
                                        ? this.displayItems
                                        : this.displayItems.map(obj => {return obj[this.itemKey]})
                        )
                )
            }
        },

        selectedItems() {
            if (this.multiple) {
                if (arrPopulated(this.value)) {
                    return this.returnObject
                            ? this.value
                            : this.items.filter(obj => this.value.includes(obj[this.itemKey]))
                } else {
                    return []
                }
            } else {
                try {
                    return this.returnObject
                            ? [this.value]
                            : this.items.filter(obj => obj[this.itemKey] === this.value)
                } catch (e) {
                    return null
                }
            }
        },
        loadingItems() {
            if (this.loading === true) {
                return this.items
            } else {
                if (this.multiple) {
                    if (arrPopulated(this.loading)) {
                        return this.returnObject
                                ? this.loading
                                : this.items.filter(obj => this.loading.includes(obj[this.itemKey]))
                    } else {
                        return []
                    }
                } else {
                    try {
                        return this.returnObject
                                ? [this.loading]
                                : this.items.filter(obj => obj[this.itemKey] === this.loading)
                    } catch (e) {
                        return null
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
    .no-bg{
        background: none;
    }
</style>